import { useContext } from 'react';

import { AssistantContext } from '../Contexts/index';

const useAssistant = () => {
  const context = useContext(AssistantContext);

  return context;
};

export default useAssistant;
